export default function CustomerDetailsSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 animate-pulse">

      {/* LEFT COLUMN */}
      <div className="lg:col-span-1 space-y-6">

        {/* Profile Skeleton */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <div className="flex flex-col items-center text-center">
            <div className="w-28 h-28 rounded-full bg-slate-200" />

            <div className="h-4 w-32 bg-slate-200 rounded mt-4" />
            <div className="h-3 w-24 bg-slate-200 rounded mt-2" />

            <div className="mt-5 flex gap-2 w-full">
              <div className="h-8 flex-1 bg-slate-200 rounded-lg" />
              <div className="h-8 flex-1 bg-slate-200 rounded-lg" />
            </div>
          </div>
        </div>

        {/* Address Skeleton */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm space-y-3">
          <div className="h-4 w-24 bg-slate-200 rounded mb-2" />
          <div className="h-3 w-full bg-slate-200 rounded" />
          <div className="h-3 w-3/4 bg-slate-200 rounded" />
          <div className="h-3 w-2/3 bg-slate-200 rounded" />
          <div className="h-3 w-1/2 bg-slate-200 rounded" />
        </div>
      </div>

      {/* RIGHT COLUMN */}
      <div className="lg:col-span-3 space-y-6">

        {/* About Skeleton */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <div className="h-4 w-40 bg-slate-200 rounded mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="h-4 bg-slate-200 rounded" />
            <div className="h-4 bg-slate-200 rounded" />
            <div className="h-4 bg-slate-200 rounded" />
          </div>
        </div>

        {/* Devices Skeleton */}
        <div className="bg-white border rounded-2xl p-6 shadow-sm">
          <div className="h-4 w-48 bg-slate-200 rounded mb-4" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {[1, 2].map((i) => (
              <div
                key={i}
                className="border rounded-xl p-4 bg-slate-50"
              >
                <div className="flex gap-4">
                  <div className="w-20 h-20 bg-slate-200 rounded-lg" />

                  <div className="flex-1 space-y-3">
                    <div className="h-4 w-3/4 bg-slate-200 rounded" />
                    <div className="h-3 w-1/2 bg-slate-200 rounded" />

                    <div className="grid grid-cols-2 gap-2">
                      <div className="h-3 bg-slate-200 rounded" />
                      <div className="h-3 bg-slate-200 rounded" />
                      <div className="h-3 bg-slate-200 rounded" />
                      <div className="h-3 bg-slate-200 rounded" />
                      <div className="h-3 bg-slate-200 rounded" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
